import { Grid, useMediaQuery } from "@mui/material";
import React from "react";
import img1 from "../../Assest/Images/award1.svg";
import img2 from "../../Assest/Images/creditawardnew.png";
import img3 from "../../Assest/Images/award3.svg";
import "./Award.css";
import AnimationSlideTop from "../../Animation/AnimationSlideTop";
function Award() {
  const isMobile = useMediaQuery("(max-width:600px)");
  return (
    <div>
      <Grid container spacing={4} p={4}>
        <Grid item xs={12} sm={4}>
          <AnimationSlideTop
            duration={1.2}
            rootMargin={isMobile ? "10px" : "-110px"}
          >
            <div sx={{ borderRadius: "40px" }}>
              <img
                src={img1}
                alt="img1"
                style={{ width: isMobile ? "80%" : "80%" }}
                // onClick={() => {
                //   navigate(Routings.ACCREDITED);
                //   window.scrollTo({ top: 0, behavior: "auto" });
                // }}
              />
              <div className="textSize">
                <p
                  style={{ fontSize: isMobile ? "16px" : "20px" }}
                 
                >
                  Accredited by Georgia Accrediting Commission
                </p>
              </div>
            </div>
          </AnimationSlideTop>
        </Grid>
        <Grid item xs={12} sm={4}>
          <AnimationSlideTop
            duration={1.5}
            rootMargin={isMobile ? "10px" : "-110px"}
          >
            <div sx={{ borderRadius: "40px" }}>
              <img
                src={img2}
                alt="img2"
                style={{ width: isMobile ? "80%" : "80%" }}
                // onClick={() => {
                //   navigate(Routings.AWARDPART);
                //   window.scrollTo({ top: 0, behavior: "auto" });
                // }}
              />
              <div className="textSize">
                <p style={{ fontSize: isMobile ? "16px" : "20px" }}
                 
                  >
                  Credits Awarded
                </p>
              </div>
            </div>
          </AnimationSlideTop>
        </Grid>
        <Grid item xs={12} sm={4}>
          <AnimationSlideTop
            duration={1.8}
            rootMargin={isMobile ? "10px" : "-110px"}
          >
            <div sx={{ borderRadius: "40px" }}>
              <img
                src={img3}
                alt="img3"
                style={{ width: isMobile ? "80%" : "80%" }}
                // onClick={() => {
                //   navigate(Routings.BILITERACY);
                //   window.scrollTo({ top: 0, behavior: "auto" });
                // }}
              />
              <div className="textSize">
                <p style={{ fontSize: isMobile ? "16px" : "20px" }}
                 >
                  Center for Georgia Seal of Biliteracy
                </p>
              </div>
            </div>
          </AnimationSlideTop>
        </Grid>
      </Grid>
    </div>
  );
}

export default Award;
